// @flow
import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Chunk: MarkdocTagRegistration = {
  tag: 'chunk',
  component: 'Chunk',
  attributes: {
    id: {type: String},
    steps: {type: Array},
    language: {type: String},
    chunks: {type: Array},
    when: {type: Object},
    unless: {type: Object},
  },
};
